import React from "react";
import moment from "moment";
import { CircularProgress } from "material-ui/Progress";
import { FiZapOff } from "react-icons/fi";
import { Typography } from "material-ui";
import HeatMap from "react-heatmap-grid";

export class HeatMapChart extends React.Component {
  
  render() {
    const {
      classes,
      loading,
      heatMapData,
      t,
      i18n
    } = this.props;

    if (loading || !heatMapData) {
      return <CircularProgress size={24} className={classes.buttonProgress} />;
    }

    if (heatMapData.data.length <= 0) {
      return (
        <Typography variant="body2" style={{ margin: 10, color: "#CECECE" }}>
          <FiZapOff style={{ position: "relative", top: 3, marginRight: 10 }} />
          {t("No data yet")}
        </Typography>
      );
    }

		let dateFormat = 'YYYY-MM-DD' //English date
		if(i18n.language === 'fr') {
			dateFormat = 'DD-MM-YYYY'
		} else if(i18n.language === 'en_us') {
			dateFormat = 'MM-DD-YYYY' //American date
		}

    let stretchedDateFormat = 'YYYY MM-DD' //English date
		if(i18n.language === 'fr') {
			stretchedDateFormat = 'DD-MM YYYY'
		} else if(i18n.language === 'en_us') {
			stretchedDateFormat = 'MM-DD YYYY' //American date
		}

		let dateHourFormat = 'YYYY-MM-DD HH:mm' //English date
		if(i18n.language === 'fr') {
			dateHourFormat = 'DD-MM-YYYY HH:mm'
		} else if(i18n.language === 'en_us') {
			dateHourFormat = 'MM-DD-YYYY h:mm a' //American date
		}

    let hourFormat = 'HH:mm' //English date'
    if(i18n.language === 'en_us') {
			hourFormat = 'h a' //American date
		}

    let formattedDates = heatMapData.labels.map(label => {
      return moment(label).format(dateHourFormat)
    });

    let hoursArray = new Array(24).fill(0).map((_, i) => moment().startOf("day").add(i, "hours").format(hourFormat));

    //remove the last element of heatMapData.labels if it corresponds to 00:00 (12am), to prevent having the last column of the graph containing a single cell
    if(moment(heatMapData.labels[heatMapData.labels.length-1]).format(hourFormat) === hoursArray[0]) {
      heatMapData.labels.pop();
    }

    let daysArray = [];
    let firstDate = heatMapData.labels[0]
    daysArray.push(moment(firstDate).format(dateFormat));
    for (let i = 0; i< heatMapData.labels.length; i++) {
      if(moment(heatMapData.labels[i]).diff(firstDate, "days") >= 1) {
        firstDate = heatMapData.labels[i];
        daysArray.push(moment(firstDate).format(dateFormat))
      }
    }

    const xLabelsVisibility = daysArray
    .map((day, i) => (i % 2 === 0 ? true : false));

    const data_heatmap = new Array(hoursArray.length)
      .fill(0).map((hour_, hourIndex) => new Array(daysArray.length).fill(0).map( (day_, dayIndex) => {
        let day = daysArray[dayIndex]
        let completeDate = moment(day, dateFormat).add(hourIndex, "hours").format(dateHourFormat);
        let date_index_in_formattedDates_array = formattedDates.indexOf(completeDate);

        let totalConsumptionForDate = heatMapData.data[heatMapData.data.length-1].data[date_index_in_formattedDates_array];
        
        if(totalConsumptionForDate) {
          let matchedConsumptionForDate = 0;
          for(let i=0; i<heatMapData.data.length-1; i++) {
            matchedConsumptionForDate += heatMapData.data[i].data[date_index_in_formattedDates_array]
          }
          let matchingPercentage = (matchedConsumptionForDate / totalConsumptionForDate) * 100;
          return Math.floor(matchingPercentage)
        }
        else {
          return Math.floor(0)
        }
      }));

      return(
        <div style={{ fontSize: "0.8vw", color: "#666666"}}>
          <HeatMap
            xLabels={daysArray.map(day => moment(day, dateFormat).format(stretchedDateFormat))}
            yLabels={hoursArray}
            data={data_heatmap}
            squares={false}
            height={15}
            xLabelsLocation={"bottom"}
            xLabelsVisibility={xLabelsVisibility}
            xLabelWidth={30}
            yLabelWidth={60}
            yLabelTextAlign={"center"}
            cellStyle={(background, value, min, max, data, x, y) => ({
              background: `rgba(53, 179, 255, ${1 - (100 - value) / 100})`
            })}
            title={(value, unit, x, y) => `${daysArray[x]} ${hoursArray[y]}\n${t("ratio")}: ${value}%`}
          />
        </div>
    );  
  }
}


// WEBPACK FOOTER //
// ./src/components/ChartCards/HeatMapChart.js